import type { FC } from "react";
import { ASSISTANT_AVATAR } from "@/theme/tokens";
import { pointsOnArc } from "@/ui/AssistantAvatar/assistantAvatarGeometry";

const PETALS = pointsOnArc(0, 0, 7, 0, 288, 72);
const { ACCESSORY } = ASSISTANT_AVATAR;

interface AvatarFlowerProps {
	/** SVG transform placing the flower (drawn around 0,0) on the figure. */
	transform: string;
}

/** A five-petal flower worn on the head. */
export const AvatarFlower: FC<AvatarFlowerProps> = ({ transform }) => (
	<g transform={transform}>
		{PETALS.map(({ x, y }) => (
			<circle key={`${x}-${y}`} cx={x} cy={y} r={5.5} fill={ACCESSORY.FLOWER_PETAL} />
		))}
		<circle r={4.5} fill={ACCESSORY.FLOWER_CENTER} />
	</g>
);
